var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pt-2"},[_c('div',{staticClass:"flex justify-between items-center mb-6"},[_c('div',{staticClass:"font-bold text-lg"},[_vm._v(_vm._s(_vm.$t('Live')))]),_vm._m(0)])]),_c('div',[_c('ResultsPoll',{attrs:{"eventData":_vm.eventData,"livePoll":_vm.livePoll}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('div',{staticStyle:{"height":"44px"}})])
}]

export { render, staticRenderFns }